import React, {useState, useEffect} from 'react';
import {Timeline, TimelineEvent} from 'react-event-timeline';
import ReactTooltip from "react-tooltip";

import * as Constant from '@app/Constant.js';
import Spinner from '../../../components/Spinner';

import AppVersionLogUpdateForm from './AppVersionLogUpdateForm.js';

const AppVersionLogTimeline = ({appId, list, dataCallback}) => {
    const [selectedId, setSelectedId] = useState(null);
    const [appVersionModalShow, setVersionModalShow] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [platformList, setPlatformList] = useState([])


    useEffect(() => {
        if(list) {
            const platforMap = {
                0 : {
                    id: 0,
                    name:'전체',
                    icon: 'fa-buromobelexperte',
                    color: 'success'
                }
            };
            list.forEach(l => {
                if(!platforMap[l.platform_id]) {
                    platforMap[l.platform_id] = {
                        id: l.platform_id,
                        name: l.platform_name,
                        icon: l.platform_icon,
                        color: l.platform_icon_color
                    }
                }
            });
            const pltoformIds = Object.keys(platforMap);
            const platforms = [];
            pltoformIds.forEach(id => {
                platforms.push(platforMap[id]);
            });
            setPlatformList(platforms);
        }
        

        return () => {};
    }, [appId, list]);
    
    if(!list || list.length == 0) {
        return (
            <div className="text-center pt-4">
                <i className="display-5 fas fa-question mb-3 mt-5 text-secondary"/>
                <h3 className="text-secondary">No Data To Show</h3>
            </div>
        )
    }

    const openPopup = (logId) => {
        setSelectedId(logId);
        setVersionModalShow(true);
    }

    const filteredList = [];
    list.forEach(l => {
        if(activeTab == 0 || l.platform_id == activeTab) {
            filteredList.push(l);
        }
    });

    return (
        <>
            <div className="simple-card">
                <ul className="nav nav-tabs">
                    {
                        platformList.map((p) => {
                            return (
                                <li className={`nav-item`}>
                                    <a
                                        className={`nav-link p-1 pr-3 pl-3 ${activeTab == p.id ? ' active' : ' '}`}
                                        href="#none"
                                        onClick={(e)=>{
                                            e.preventDefault();
                                            setActiveTab(`${p.id}`);
                                        }}
                                    >
                                        <span className={`icon-circle font-18 pr-2 text-${p.color} bg-{p.color}-light`}>
                                            <i className={`fab ${p.icon}`}></i>
                                        </span>
                                        {p.name}
                                    </a>
                                </li>
                            );
                            
                        })
                    }
                </ul>
            
                <div className="tab-content">
                    <div className='tab-pane active' style={{maxHeight: '450px', overflow:'auto'}}>
                         <Timeline lineColor="#5969ff">
                            {
                                filteredList.map(l => {
                                    return (
                                        <TimelineEvent
                                            className="border-bottom mb-2"
                                            buttons={
                                                <i
                                                    className="far fa-edit text-primary mr-4"
                                                    style={{cursor:'pointer'}}
                                                    onClick={()=> openPopup(`${l.id}`)}
                                                />
                                            }
                                            title={
                                                <h4 className="mb-0">
                                                    {` ver. ${l.major}.${l.minor}.${l.revision}`}
                                                    {l.code ? ` (${l.code})` : ''}
                                                    <span className="ml-2 text-muted font-14">{l.deploy_date} 배포</span>
                                                </h4>
                                            }
                                            subtitle={
                                                    <h5 className="mb-0 text-muted">{l.qa_charger}</h5>
                                            }
                                            icon={
                                                <>
                                                    <span className={`icon-circle font-24 pl-2 pr-2 text-${l.platform_icon_color} bg-${l.platform_icon_color}-light`} data-tip data-for={`deployDate_${l.id}`} effect='solid'>
                                                        <i className={`fab ${l.platform_icon}`}></i>
                                                    </span>
                                                    <ReactTooltip id={`deployDate_${l.id}`} type='dark'>
                                                        <span>{l.deploy_date}</span>
                                                    </ReactTooltip>
                                                </>
                                            }
                                            iconStyle={{
                                                left: '-3px'
                                            }}
                                            contentStyle={{
                                                color: 'black'
                                            }}
                                        >
                                            <pre className="pt-1 pb-1 pr-2 pl-2 font-14" style={{color: 'black !important', fontFamily: 'Circular Std Book', fontWeight: 'normal'}}>
                                                    {l.desc}
                                            </pre>
                                        </TimelineEvent>
                                    )
                                })
                            }
                        </Timeline>
                    </div>
                </div>
            </div>
                

            <AppVersionLogUpdateForm
                logId={selectedId}
                appId={appId}
                show={appVersionModalShow}
                onHide={()=> {
                    setVersionModalShow(false);
                }}
                dataCallback={(appId)=> {
                    dataCallback(appId);
                }}
            />  
        </>
    );
}

export default AppVersionLogTimeline;